(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jc-quick-view"] && !Shopify.designMode) return;
  try {
    (function () {
    var dialog = document.getElementById('JcQuickView');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var JC_SOFTEN = dialog.dataset.jcSoften !== 'false';

    var heroImg = dialog.querySelector('[data-jc-qv-hero-img]');
    var scarcity = dialog.querySelector('[data-jc-qv-scarcity]');
    var thumbs = dialog.querySelector('[data-jc-qv-thumbs]');
    var eyebrow = dialog.querySelector('[data-jc-qv-eyebrow]');
    var titleEl = dialog.querySelector('[data-jc-qv-title]');
    var descEl = dialog.querySelector('[data-jc-qv-desc]');
    var priceEl = dialog.querySelector('[data-jc-qv-price]');
    var specsBody = dialog.querySelector('[data-jc-qv-specs]');
    var specsTable = specsBody.closest('.jc-quick-view__specs');
    var sizesRow = dialog.querySelector('[data-jc-qv-sizes]');
    var atcBtn = dialog.querySelector('[data-jc-qv-atc]');
    var atcIcon = dialog.querySelector('[data-jc-qv-atc-icon]');
    var atcLabel = dialog.querySelector('[data-jc-qv-atc-label]');
    var statusEl = dialog.querySelector('[data-jc-qv-status]');
    var closeBtn = dialog.querySelector('[data-jc-quick-view-close]');

    var ICON_BAG = atcIcon.innerHTML;
    var ICON_CHECK =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"></path></svg>';
    var ATC_LABEL_DEFAULT = atcLabel.textContent;

    var lastTrigger = null;
    var currentProduct = null;
    var selectedVariantId = null;
    var productRequest = null;
    var productRequestId = 0;
    var addedTimer = null;

    function money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify.currency.active || 'USD' }).format(cents / 100);
    }

    function setGallery(images, alt) {
      var list = images.length ? images : [];
      thumbs.innerHTML = '';

      function show(i) {
        heroImg.src = list[i] || '';
        heroImg.alt = alt;
      }

      show(0);

      if (list.length > 1) {
        list.forEach(function (src, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'jc-quick-view__thumb' + (i === 0 ? ' is-active' : '') + (JC_SOFTEN ? ' jc-photo-soften' : '');
          b.setAttribute('aria-label', 'View image ' + (i + 1));
          var img = document.createElement('img');
          img.src = src;
          img.alt = '';
          b.appendChild(img);
          b.addEventListener('click', function () {
            show(i);
            thumbs.querySelectorAll('.jc-quick-view__thumb').forEach(function (t) {
              t.classList.remove('is-active');
            });
            b.classList.add('is-active');
          });
          thumbs.appendChild(b);
        });
      }
    }

    function updatePrice(variant) {
      priceEl.textContent = money(variant.price);
      atcLabel.textContent = ATC_LABEL_DEFAULT + ' · ' + money(variant.price);
    }

    function setSoldOut() {
      atcBtn.disabled = true;
      atcLabel.textContent = 'Sold out';
    }

    function setSizes(variants) {
      sizesRow.innerHTML = '';
      var firstAvailable = null;

      // Single default-variant products (Shopify's "Default Title") have no
      // real size choice — hide the whole Size row instead of showing a
      // meaningless "Default Title" button.
      var sizesWrap = sizesRow.closest('.jc-quick-view__sizes');
      var isDefaultOnly = variants.length === 1 && (variants[0].title === 'Default Title' || variants[0].public_title === null);
      if (sizesWrap) sizesWrap.hidden = isDefaultOnly || variants.length === 0;
      if (isDefaultOnly) {
        selectedVariantId = variants[0].id;
        updatePrice(variants[0]);
        if (variants[0].available) {
          atcBtn.disabled = false;
        } else {
          setSoldOut();
        }
        return;
      }

      variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'jc-quick-view__size';
        b.textContent = v.public_title || v.title;
        b.disabled = !v.available;
        b.addEventListener('click', function () {
          selectedVariantId = v.id;
          sizesRow.querySelectorAll('.jc-quick-view__size').forEach(function (s) {
            s.classList.remove('is-selected');
          });
          b.classList.add('is-selected');
          updatePrice(v);
          if (v.available) {
            atcBtn.disabled = false;
          } else {
            setSoldOut();
          }
        });
        if (!firstAvailable && v.available) firstAvailable = { el: b, variant: v };
        sizesRow.appendChild(b);
      });

      var pick = firstAvailable || (variants.length ? { el: sizesRow.children[0], variant: variants[0] } : null);
      if (pick) {
        pick.el.classList.add('is-selected');
        selectedVariantId = pick.variant.id;
        updatePrice(pick.variant);
        if (pick.variant.available) {
          atcBtn.disabled = false;
        } else {
          setSoldOut();
        }
      } else {
        setSoldOut();
      }
    }

    function setDetailsLink(url) {
      var dl = dialog.querySelector('[data-jc-qv-details]');
      if (dl) dl.href = url;
    }

    function setSpecs(trigger) {
      var rows = [
        ['Metal', trigger.dataset.metal],
        ['Purity', trigger.dataset.purity],
        ['Gram weight', trigger.dataset.gramWeight],
        ['Category', trigger.dataset.category],
      ];
      specsBody.innerHTML = '';
      rows.forEach(function (r) {
        if (!r[1]) return;
        var tr = document.createElement('tr');
        var th = document.createElement('th');
        th.scope = 'row';
        th.textContent = r[0];
        var td = document.createElement('td');
        td.textContent = r[1];
        tr.appendChild(th);
        tr.appendChild(td);
        specsBody.appendChild(tr);
      });
      if (specsTable) specsTable.hidden = specsBody.children.length === 0;
    }

    function resetAtc() {
      atcIcon.innerHTML = ICON_BAG;
      atcLabel.textContent = ATC_LABEL_DEFAULT;
    }

    function cancelProductRequest() {
      window.clearTimeout(addedTimer);
      productRequestId += 1;
      if (productRequest) productRequest.abort();
      productRequest = null;
    }

    function openFor(trigger) {
      cancelProductRequest();
      var requestId = ++productRequestId;
      var productUrl = trigger.dataset.productUrl || trigger.href;
      lastTrigger = trigger;
      currentProduct = null;
      selectedVariantId = null;
      sizesRow.replaceChildren();
      sizesRow.closest('.jc-quick-view__sizes').hidden = true;
      thumbs.replaceChildren();
      heroImg.removeAttribute('src');
      resetAtc();
      atcBtn.disabled = true;
      atcLabel.textContent = 'Loading…';
      statusEl.textContent = '';
      setSpecs(trigger);
      if (productUrl) setDetailsLink(productUrl);
      scarcity.hidden = trigger.dataset.oneAvailable !== 'true';
      titleEl.textContent = '';
      priceEl.textContent = '';
      eyebrow.textContent = trigger.dataset.metal || '';

      if (!dialog.open) dialog.showModal();

      if (!productUrl) {
        atcLabel.textContent = 'Unavailable';
        statusEl.textContent = 'Could not load product details.';
        return;
      }

      productRequest = typeof AbortController === 'function' ? new AbortController() : null;
      var fetchOptions = { credentials: 'same-origin' };
      if (productRequest) fetchOptions.signal = productRequest.signal;

      fetch(productUrl + '.js', fetchOptions)
        .then(function (r) {
          if (!r.ok) throw new Error('Could not load product details.');
          return r.json();
        })
        .then(function (product) {
          if (requestId !== productRequestId) return;
          currentProduct = product;
          titleEl.textContent = product.title;
          descEl.textContent = 'Product details and specifications for ' + product.title;
          eyebrow.textContent = trigger.dataset.metal || product.type || '';
          setGallery((product.images || []).slice(0, 2), product.title);
          setSizes(product.variants || []);
        })
        .catch(function (err) {
          if (requestId !== productRequestId || (err && err.name === 'AbortError')) return;
          currentProduct = null;
          selectedVariantId = null;
          atcBtn.disabled = true;
          atcLabel.textContent = 'Unavailable';
          statusEl.textContent = 'Could not load product details.';
        })
        .then(function () {
          if (requestId === productRequestId) productRequest = null;
        });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-jc-quick-view-trigger]');
      if (!trigger) return;
      e.preventDefault();
      openFor(trigger);
    });

    closeBtn.addEventListener('click', function () {
      dialog.close();
    });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', function () {
      // Native close events are queued: an immediate reopen may already own a new request.
      if (dialog.open) return;
      cancelProductRequest();
      if (lastTrigger) lastTrigger.focus();
    });

    atcBtn.addEventListener('click', function () {
      var variant = currentProduct && currentProduct.variants.find(function (v) { return v.id === selectedVariantId; });
      if (atcBtn.disabled || !variant || !variant.available) return;
      var requestId = productRequestId;
      var submittedVariantId = selectedVariantId;
      atcBtn.disabled = true;
      fetch((window.Shopify.routes.root || '/') + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: submittedVariantId, quantity: 1 }] }),
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (d) {
              throw new Error((d && d.description) || 'Could not add to cart.');
            });
          }
          return r.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'jc-quick-view' });
          if (requestId !== productRequestId || !dialog.open) return;
          atcIcon.innerHTML = ICON_CHECK;
          atcLabel.textContent = 'Added to cart';
          statusEl.textContent = 'Added to cart.';
          addedTimer = window.setTimeout(function () {
            if (requestId !== productRequestId || !dialog.open) return;
            resetAtc();
            if (currentProduct) {
              var v = currentProduct.variants.filter(function (variant) {
                return variant.id === selectedVariantId;
              })[0];
              if (v) updatePrice(v);
            }
            atcBtn.disabled = !v || !v.available;
          }, 1800);
        })
        .catch(function (err) {
          if (requestId !== productRequestId || !dialog.open) return;
          atcBtn.disabled = !variant.available;
          statusEl.textContent = err.message || 'Could not add to cart.';
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
